module.exports = __webpack_public_path__ + "static/media/0862bd3e.jpg";